import {LogoEdit} from "./LogoEdit";

export const HeaderEdit = () => {

    return(
        <div style={{width: '100%'}}>
            <LogoEdit/>
        </div>
    )
}